<template>
  <v-footer
    id="dashboard-core-footer"
  >
    <v-container>
      <v-row
        align="center"
        no-gutters
      >
        <v-spacer class="hidden-sm-and-down"/>

        <v-col
          cols="12"
        >
          <div class="body-1 font-weight-light pt-12 pt-md-0 text-center">
            Bản quyền thuộc về Công ty TNHH MTV Vận Tải Thương Mại Dịch Vụ MPC | &copy; 2020-2021 - Phiên bản: {{version}}
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'DashboardCoreFooter',

    data: () => ({
      version: process.env.VUE_APP_VERSION
    }),
  }
</script>

<style lang="sass">
  #dashboard-core-footer
    a
      font-size: .825rem
      font-weight: 500
      text-decoration: none
      text-transform: uppercase
</style>
